import { combineReducers } from 'redux';
import { configureStore } from '@reduxjs/toolkit';

import authorReducer from './author';
import authorwillReducer from './authorwill';
import testamentReducer from './testament';
import heiressReducer from './heiress';
import moneyReducer from './money';
import automobileReducer from './automobile';
import bondReducer from './bond';
import buildingReducer from './building';
import apartmentReducer from './apartment';
import debtReducer from './debt';
import depositReducer from './deposit';
import fundReducer from './fund';
import insuranceReducer from './insurance';
import landReducer from './land';
import otherReducer from './other';
import stockReducer from './stock';
import igonReducer from './igon';

const reducer = combineReducers({
    author: authorReducer,
    authorwill: authorwillReducer,
    testament: testamentReducer,
    heiress: heiressReducer,
    money: moneyReducer,
    automobile: automobileReducer,
    bond: bondReducer,
    building: buildingReducer,
    apartment: apartmentReducer,
    debt: debtReducer,
    deposit: depositReducer,
    fund: fundReducer,
    insurance: insuranceReducer,
    land: landReducer,
    other: otherReducer,
    stock: stockReducer,
    igon: igonReducer,
});

const store = configureStore({ reducer });

export default store;
